export const profileTypeOptions = [
  { value: 'corporate', label: 'Corporate' },
  { value: 'family', label: 'Family' },
  { value: 'list_price', label: 'List Price' },
  { value: 'floor_price', label: 'Floor Price' },
  { value: 'custom', label: 'Custom' },
  { value: 'default', label: 'Default' },
];
